import Image from 'components/Basic/Image/Image';
import Checkbox from 'components/Forms/Checkbox/Checkbox';

type StoreServiceCheckboxProps = {
    checked: boolean;
    icon: string | null;
    id: string;
    label: string;
    onChange: (isChecked: boolean) => void;
};

export const StoreServiceCheckbox: FC<StoreServiceCheckboxProps> = ({ checked, icon, id, label, onChange }) => (
    <div className="flex items-center gap-3">
        {icon !== null && <Image alt="" height={30} src={icon} width={30} />}
        <Checkbox
            checked={checked}
            id={id}
            label={label}
            name={id}
            onChange={(event) => onChange(event.target.checked)}
        />
    </div>
);
